import { useViewport } from "@xyflow/react"
import { type ReactElement, useMemo } from "react"
import { useCursor } from "../../contexts/cursor"
import { RemoteCursor } from "./RemoteCursor"

export function CursorLayer() {
	const { remoteCursors, peers, debugMode } = useCursor()
	const viewport = useViewport()

	const cursorElements = useMemo(() => {
		const elements: ReactElement[] = []

		for (const [userId, cursor] of remoteCursors) {
			const userInfo = peers.get(userId)
			if (!userInfo) continue

			// Transform canvas coordinates to screen coordinates
			const screenX = cursor.position.x * viewport.zoom + viewport.x
			const screenY = cursor.position.y * viewport.zoom + viewport.y

			const transformedCursor = {
				...cursor,
				position: { x: screenX, y: screenY },
			}

			elements.push(
				<RemoteCursor
					key={userId}
					cursor={transformedCursor}
					userInfo={userInfo}
					showDebug={debugMode}
				/>,
			)
		}

		return elements
	}, [remoteCursors, peers, debugMode, viewport])

	return (
		<div className="pointer-events-none absolute inset-0 overflow-hidden">
			{cursorElements}
		</div>
	)
}
